import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const updateSemester = createAsyncThunk('updateSemester', async (data) => {

    try {
        const res = await axios({

            method: 'PUT',
            url: getConfig.API_URL + `semester`,
            data: {
                "semester_id": data?.values?.id,
                "semester_name": data?.values?.semesterName,
                "status": data?.values?.status
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})
